import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import { CountryBannerContainer } from '#src/app/shared/components/banners/country';
import { useCountryBanner } from '#src/app/shared/hooks/banners/country';

import { EmergencyBannerContainer } from './EmergencyBanner';
import { StarterDashPromptingBanner } from './StarterDashPromptingBanner';

export const BannerContainer: React.FC = () => {
	const {
		data: { signed, starterDashboardPromptingBannerEnabled },
	} = usePetitionDetailsPageUserData();
	const {
		data: {
			petition: { id: petitionId, emergencyBannerContent: emergencyBanner },
		},
	} = usePetitionDetailsPageData();

	const countryBanner = useCountryBanner('petition', { id: petitionId, signed });

	if (emergencyBanner) {
		return <EmergencyBannerContainer emergencyBanner={emergencyBanner} />;
	}

	if (starterDashboardPromptingBannerEnabled) {
		return <StarterDashPromptingBanner />;
	}

	if (countryBanner) {
		return <CountryBannerContainer petitionId={petitionId} context="petition" countryBanner={countryBanner} />;
	}

	return null;
};
